import { useFormik } from "formik";
import { useCallback, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useQueryClient } from "react-query";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { GetMomentoEntrega } from "../../../../api/Api";
import ConfirmWithLoader from "../../../../Components/Modals/ConfirmWithLoader";
import UploadZone from "../../../../Components/Upload/UploadZone";

export default function MomentoEntregaModal({
  showModal = false,
  setShowModal,
  isFinishSave = false,
  onConfirm,
  onClose,
  messageError,
  title,
  value,
  urlFile,
  fileName,
  showMessageUploadLink,
  setUrlFile,
  setFileName,
  setShowMessageUploadLink
}) {

  const [isLoadingSave, setIsLoadingSave] = useState(true);
  const [momentosEntregaOptions, setMomentosEntregaOptions] = useState([]);

  // const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  // const [urlFile, setUrlFile] = useState("");

  const queryClient = useQueryClient();

  const { values: formikValues,
    setFieldValue: setFormikFieldValue,
    handleSubmit: handleSubmitFormik } = useFormik({
      initialValues: {
        momentoEntrega: value?.momentoEntrega || null
      },
      enableReinitialize: true,
      onSubmit: (values) => {
        setIsLoadingSave(true);
        onConfirm && onConfirm(values, file);
      }
    })

  useEffect(() => {
    if (showModal) {
      queryClient.fetchQuery('getMomentoEntrega', GetMomentoEntrega).then((result) => {
        if (result.success) {
          const options = result.data.map(item => ({
            value: item.codigo,
            label: item.descripcion
          }));
          setMomentosEntregaOptions(options);
        }

      }).catch((err) => {
      }).finally(() => {
        setIsLoadingSave(false);
      });
    }
  }, [showModal, queryClient])

  const validateButtonConfirm = useCallback(() => {
    return !(formikValues.momentoEntrega)
  }, [formikValues.momentoEntrega])

  const handleClose = useCallback(() => {
    setIsLoadingSave(true);
    setFile(null);
    setUrlFile(null);
    setFileName(null);
    setShowMessageUploadLink(false)
    onClose && onClose();
  }, [onClose, setFileName, setShowMessageUploadLink, setUrlFile])

  useEffect(() => {
    if (isFinishSave) {
      setIsLoadingSave(false);
    }
  }, [isFinishSave])

  useEffect(() => {
    if (urlFile) {
      setFile(null);
    }
  }, [urlFile])

  const customDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      return;
    }
    setFile(acceptedFiles[0]);
    setFileName(acceptedFiles[0].path);
    setShowMessageUploadLink(false);

  }, [setFileName, setShowMessageUploadLink]);

  return (
    <>
      <ConfirmWithLoader
        showModal={showModal}
        setShowModal={setShowModal}
        title={title}
        isLoading={isLoadingSave}
        isFinish={isFinishSave}
        disabledConfirmButton={validateButtonConfirm()}
        hideContentInLoading={false}
        hideActionAfterConfirm={false}
        textButtonCancel={"Cerrar"}
        textButton={"Guardar"}
        onConfirm={() => handleSubmitFormik()}
        onClose={handleClose}
      >
        {!isLoadingSave && isFinishSave && (
          messageError ? (
            <Alert key='error' variant='primary' className='mb-8'>
              <b>Error</b>: {messageError}
            </Alert>
          ) : (
            <Alert key='info' variant='success' className='mb-8'>
              <b>Guardado Exitoso</b>: El Tipo de momento de entrega se ha guardado exitosamente.
            </Alert>
          )
        )}
        <div className="container">
          <div className="row">
            <div className="col-12 d-flex align-items-center">
              <label className="fw-bold fs-6 me-4 label-form-cheque text-end">Momento:</label>
              <Select
                classNamePrefix='filter'
                components={makeAnimated()}
                value={formikValues.momentoEntrega}
                options={momentosEntregaOptions}
                isMulti={false}
                closeMenuOnSelect={true}
                placeholder="Selecciona"
                className="flex-grow-1 w-auto"
                isSearchable={false}
                onChange={(value) => { setFormikFieldValue(`momentoEntrega`, value) }}
              />
            </div>
            <div className="col-12 d-flex align-items-center mt-5">
              <label className="fw-bold fs-6 me-4 label-form-cheque text-end">Sustento:</label>
            </div>
            <div className="col-12 mt-4">
              <UploadZone
                onDrop={customDrop}
                fileUrl={urlFile}
                fileName={fileName}
                isLoading={false}
                showMessageUploadLink={showMessageUploadLink}
              // isDisabled={disableFormInputs}
              />

            </div>
          </div>
        </div>


      </ConfirmWithLoader>
    </>
  );
}